/**
 * Libellés français des rôles de tiers.
 *
 * L'API parle en codes (`SUPPLIER`), l'interface parle métier (« Fournisseur »).
 * La traduction vit ici, en un seul endroit : deux écrans qui la dupliquent
 * finissent toujours par diverger — c'est exactement ce qui s'était produit
 * entre la liste des tiers et le rapport d'import.
 */
import type { PartyRoleKind } from '../api/client';

export const ROLE_LIBELLE: Record<PartyRoleKind, string> = {
  CUSTOMER: 'Client',
  SUPPLIER: 'Fournisseur',
  SUBCONTRACTOR: 'Sous-traitant',
  CONTROL_BODY: 'Organisme de contrôle',
  MANUFACTURER: 'Fabricant',
  BRAND: 'Marque',
};

/** Ordre d'affichage stable des rôles (listes déroulantes, filtres). */
export const ROLES_ORDONNES = Object.keys(ROLE_LIBELLE) as PartyRoleKind[];

/**
 * Les rôles d'un formulaire de tiers à son ouverture : en CORRECTION, ceux que le tiers porte déjà ; en CRÉATION, ceux que le bouton
 * d'origine annonce (« Nouveau client » ouvre le formulaire avec « Client » coché). Une copie : le formulaire coche et décoche sans
 * jamais toucher à la liste reçue.
 */
export function rolesDeDepart(
  tiers: { readonly roles?: readonly PartyRoleKind[] } | null,
  rolesInitiaux: readonly PartyRoleKind[] = [],
): PartyRoleKind[] {
  return tiers ? [...(tiers.roles ?? [])] : [...rolesInitiaux];
}

/**
 * Traduit un code de rôle, même inconnu.
 *
 * Un code ajouté côté serveur et pas encore ici doit rester lisible plutôt que
 * de disparaître de l'écran.
 */
export function libelleRole(code: string): string {
  return ROLE_LIBELLE[code as PartyRoleKind] ?? code;
}
